import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AppButton, AppButtonVariant} from '../AppButton';
import GeoMap from '../GeoMap/GeoMap';

export interface IConfirmAddress {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export interface ConfirmAddressContentProps {
  onClose: () => void;
  onContinue: () => void;
  confirmAddress: IConfirmAddress;
}

const ConfirmAddressContent: React.FC<ConfirmAddressContentProps> = ({
  onClose,
  onContinue,
  confirmAddress,
}) => {
  const {t} = useTranslation();
  return (
    <Box className="confirm-address-modal">
      <Box className="confirm-address-modal-header">
        <Typography className="confirm-address-modal-title">
          {t('confirm_address_modal.title')}
        </Typography>
      </Box>

      <Box className="confirm-address-map">
        <GeoMap
          line1={confirmAddress.addressLine1}
          city={confirmAddress.city}
          country={confirmAddress.country}
          state={confirmAddress.state}
          postal_code={confirmAddress.zipCode}
        />
        <Box className="confirm-address-content">
          <Box>
            <Typography className="confirm-address-text address-line">
              {confirmAddress.addressLine1}
            </Typography>
            {confirmAddress.addressLine2 && (
              <Typography className="confirm-address-text address-line">
                {confirmAddress.addressLine2}
              </Typography>
            )}
            <Typography className="confirm-address-text">
              {confirmAddress.city}, {confirmAddress.state}{' '}
              {confirmAddress.zipCode}
            </Typography>
            <Typography className="confirm-address-text">
              {confirmAddress.country}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="confirm-address-modal-actions">
        <AppButton
          id="confirm-address-modal-edit"
          label={t('confirm_address_modal.edit')}
          onClick={onClose}
          variant={AppButtonVariant.onTertiary}
        />
        <AppButton
          id="confirm-address-modal-confirm"
          label={t('confirm_address_modal.confirm')}
          onClick={onContinue}
          variant={AppButtonVariant.onPrimary}
        />
      </Box>
    </Box>
  );
};

export default ConfirmAddressContent;
